import React, { useState } from 'react';
import { config } from '../config';
import { useNotification } from '../components/Notification';
import './Contact.css';

function Support() {
  const { showNotification } = useNotification();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${config.API_URL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          subject: formData.category 
            ? `[Support - ${formData.category}] ${formData.subject}`
            : `[Support] ${formData.subject}`
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Fehler beim Senden der Nachricht');
      }

      showNotification('Support-Anfrage erfolgreich gesendet! Wir melden uns schnellstmöglich bei Ihnen.', 'success');
      setFormData({
        name: '',
        email: '',
        category: '',
        subject: '',
        message: ''
      });
      e.target.reset();
    } catch (error) {
      console.error('Support form error:', error);
      showNotification(error.message || 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>Support</h1>
        <p className="contact-intro">
          Benötigen Sie Hilfe oder haben Sie Fragen zu GarageDesk? Unser Support-Team steht Ihnen gerne zur Verfügung!
        </p>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">E-Mail-Adresse *</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="category">Kategorie *</label>
            <select
              id="category"
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              required
            >
              <option value="">Bitte wählen...</option>
              <option value="Technisches Problem">Technisches Problem</option>
              <option value="Funktionsfrage">Funktionsfrage</option>
              <option value="Fehlerbericht">Fehlerbericht</option>
              <option value="Feature-Anfrage">Feature-Anfrage</option>
              <option value="Account-Frage">Account-Frage</option>
              <option value="Rechnung">Rechnung</option>
              <option value="Sonstiges">Sonstiges</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="subject">Betreff *</label>
            <input
              type="text"
              id="subject"
              value={formData.subject}
              onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
              placeholder="z.B. Frage zu Funktion X, Problem mit..."
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Nachricht *</label>
            <textarea
              id="message"
              rows="8"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              placeholder="Bitte beschreiben Sie Ihr Anliegen so detailliert wie möglich..."
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Wird gesendet...' : 'Support-Anfrage senden'}
          </button>
        </form>

        <div className="contact-info">
          <h2>Weitere Informationen</h2>
          <p>
            Für allgemeine Fragen können Sie auch unser <a href="/contact">Kontaktformular</a> verwenden.
          </p>
          <p>
            Weitere Informationen finden Sie in der <a href="/documentation">Dokumentation</a> oder im <a href="/impressum">Impressum</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Support;

